import ADE from "./ADE";
import AOL from "./AOL";

export const getTranslations = clientCode => {
  if (clientCode === "AOL") return AOL;
  if (clientCode === "ADE") return ADE;
  if (clientCode === "TUK") return AOL;
};
